export interface UserRoleScopes {
  test: boolean;
  isAdmin: boolean;
  managePods: boolean;
  isDeveloper: boolean;
  manageUsers: boolean;
  manageUserRoles: boolean;
  manageBranches: boolean;
  manageBusinesses: boolean;
  manageBusinessUsers: boolean;
  manageBusinessUploads: boolean;
  manageSupportDesk: boolean;
  manageUploadSubmissions: boolean;
  manageBusinessDataSources: boolean;
  manageCreativeHubTemplates: boolean;
  creativeHubEditor: boolean;
  creativeHubPublisher: boolean;
  creativeHubDecisionMaker: boolean;
  campaignBuilderPublish: boolean;
  campaignBuilderBulkPublish: boolean;
  manageBusinessBadData: boolean;
  reviewBusinessBadData: boolean;
}

export const exampleUserRoleScopes: UserRoleScopes = {
  test: false,
  isAdmin: false,
  managePods: false,
  isDeveloper: false,
  manageUsers: false,
  manageBranches: false,
  manageUserRoles: false,
  manageBusinesses: false,
  manageBusinessUsers: false,
  manageBusinessUploads: false,
  manageUploadSubmissions: false,
  manageBusinessDataSources: false,
  manageCreativeHubTemplates: false,
  manageSupportDesk: false,
  creativeHubEditor: false,
  creativeHubPublisher: false,
  creativeHubDecisionMaker: false,
  campaignBuilderPublish: false,
  campaignBuilderBulkPublish: false,
  manageBusinessBadData: false,
  reviewBusinessBadData: false,
};
